module.exports = new __parcel__URL__("closed-hihat_4.546f9296.mp3").toString();